'use client'

import { Suspense } from 'react'
import { useSearchParams } from 'next/navigation'
import { ClientDetail } from '@/features/cases'
import { Skeleton } from '@/components/ui/skeleton'
import { AdminShell } from '@/features/admin/components/admin-shell'

/** Mirrors `staff-client-detail-view.tsx`'s `StaffClientDetailContent` — see its comment for why
 * this reads `?case=` client-side (a simplification; it was investigated but did NOT fix the
 * tab-title flicker on tab switch, which is still open — see `api-progress.md`). */
function AdminClientDetailContent({ investorId }: { investorId: string }) {
  const focusCaseId = useSearchParams().get('case') ?? undefined
  return (
    <ClientDetail
      key={`${investorId}:${focusCaseId ?? ''}`}
      investorId={investorId}
      focusCaseId={focusCaseId}
      mode="admin"
      backTo="/admin/cases"
    />
  )
}

export function AdminClientDetailView({ investorId }: { investorId: string }) {
  return (
    <AdminShell active="cases" fullHeight>
      <Suspense fallback={<Skeleton className="h-64 w-full" />}>
        <AdminClientDetailContent investorId={investorId} />
      </Suspense>
    </AdminShell>
  )
}
